/* Chery Style (okt 2026) – productpagina: geen voorgekozen maat.
   Het thema kiest zelf geen maat meer (snippets/product-option.liquid, data-error op de maatgroep). Apps zoals
   Swatch King kiezen bij het laden soms toch een maat met een niet-echte klik of zetten stil een vinkje.
   Dit script draait die keuze terug tot de klant zelf een maat aantikt. Met ?variant= in de URL doet het niets. */
(function () {
  if (window.csPdpGuard) return;
  window.csPdpGuard = true;
  var startHadVariant = /[?&]variant=/.test(window.location.search);
  window.csUserPicked = window.csUserPicked || false;

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.isTrusted && e.target && e.target.closest && e.target.closest('variant-selects, variant-swatch-king, product-add-to-cart-sticky')) window.csUserPicked = true;
    }, { capture: true, passive: true });
  });

  function active() {
    return !startHadVariant && !window.csUserPicked && !!document.querySelector('variant-selects fieldset[data-error]');
  }

  function resetAll() {
    if (!active()) return;
    var sections = {};
    document.querySelectorAll('variant-selects').forEach(function (selects) {
      selects.querySelectorAll('fieldset[data-error]').forEach(function (fieldset) {
        fieldset.querySelectorAll('input').forEach(function (input) { input.checked = false; });
        fieldset.classList.add('cs-size-open');
        var label = fieldset.querySelector('.form__label__value');
        if (label) {
          var choose = document.createElement('span');
          choose.className = 'cs-choose';
          choose.textContent = fieldset.getAttribute('data-error');
          label.replaceChildren(choose);
        }
      });
      try {
        if (selects.updateOptions) { selects.updateOptions(); selects.updateMasterId(); selects.setDisabled(); }
      } catch (e) {}
      if (selects.dataset.section) sections[selects.dataset.section] = true;
    });
    Object.keys(sections).forEach(function (id) {
      document.querySelectorAll('#product-form-' + id + ' input[name="id"]').forEach(function (input) { input.value = ''; });
    });
    document.querySelectorAll('.single-add-to-cart-button:not(.bundle-add-to-cart-button)').forEach(function (button) {
      if (!button.dataset.chooseText) return;
      var text = button.querySelector('.single-add-to-cart-button--text');
      button.removeAttribute('disabled');
      button.classList.remove('sold-out', 'loading');
      if (text) text.textContent = button.dataset.chooseText;
    });
    if (/[?&]variant=/.test(window.location.search)) {
      var url = new URL(window.location.href);
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.pathname + url.search);
    }
    stock();
  }

  /* Niet-echte wijziging (app) voordat de klant zelf koos: niet doorgeven aan het thema en terugdraaien. */
  document.addEventListener('change', function (e) {
    if (e.isTrusted || !active()) return;
    var selects = e.target && e.target.closest ? e.target.closest('variant-selects') : null;
    if (!selects || !selects.querySelector('fieldset[data-error]')) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    setTimeout(resetAll, 0);
  }, true);

  /* Stil gezette vinkjes (zonder change) na het laden opruimen. */
  function sweep() {
    if (active() && document.querySelector('variant-selects fieldset[data-error] input:checked')) resetAll();
  }
  function start() { [300, 1200, 2500, 4500].forEach(function (ms) { setTimeout(sweep, ms); }); }
  /* Apps zetten de maat al vóór 'load' (op zware pagina's pas na 8 s). Daarom ook vanaf het begin elke 250 ms
     kijken, maximaal 15 s en alleen zolang de klant zelf nog niets aantikte. */
  var sweepUntil = Date.now() + 15000;
  var sweepTimer = setInterval(function () {
    if (window.csUserPicked || Date.now() > sweepUntil) { clearInterval(sweepTimer); return; }
    sweep();
    stock();
  }, 250);

  /* Kortingspil op de foto ("Black Friday −40%"), tekst komt uit product-information.liquid. */
  function pill() {
    var src = document.querySelector('[data-cs-img-pill]');
    var box = document.querySelector('.product-gallery-container .product-image-container');
    if (!src || !box || box.querySelector('.cs-img-pill')) return;
    var span = document.createElement('span');
    span.className = 'cs-img-pill';
    span.textContent = src.getAttribute('data-cs-img-pill');
    if (box.querySelector('.cs-native-lc-badge')) span.className += ' cs-img-pill--below';
    /* op mobiel staat de foto in het midden met stukjes van de buurfoto's: pil links op de foto zelf */
    var slide = box.querySelector('.product-images__slide.is-selected') || box.querySelector('.product-images__slide');
    if (slide) {
      var offset = Math.round(slide.getBoundingClientRect().left - box.getBoundingClientRect().left);
      if (offset > 0 && offset < 120) span.style.left = (offset + 12) + 'px';
    }
    box.appendChild(span);
  }

  /* "Op voorraad in maat 39": gekozen maat achter de voorraadregel; op laatste-kans-pagina's de groene regel
     verbergen als de oranje "Nog n op voorraad" of uitverkocht geldt. */
  var sizeSuffix = null;
  function stock() {
    var selects = document.querySelector('.product-information variant-selects');
    if (!selects) return;
    var head = selects.querySelector('.cs-size-head');
    var sizeSet = head ? head.closest('fieldset') : selects.querySelector('fieldset[data-error]');
    var size = sizeSet ? sizeSet.querySelector('input:checked') : null;
    var nl = (document.documentElement.lang || 'nl').indexOf('nl') === 0;
    document.querySelectorAll('[data-cs-size-suffix]').forEach(function (el) {
      if (sizeSuffix === null) sizeSuffix = el.textContent;
      el.textContent = size && nl ? ' in maat ' + size.value : sizeSuffix;
    });
    var green = document.querySelector('[data-cs-instock]');
    if (green) {
      var low = document.querySelector('cs-lc-purchase-details [data-low-stock]');
      var form = document.getElementById('product-form-' + selects.dataset.section);
      var id = form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : '';
      var available = true;
      if (id && size) {
        try {
          var data = JSON.parse(selects.querySelector('script[type="application/json"]').textContent);
          var variant = data.filter(function (v) { return String(v.id) === String(id); })[0];
          if (variant) available = !!variant.available;
        } catch (e) {}
      }
      green.hidden = !available || (low && !low.hidden);
    }
  }
  function stockSoon() { setTimeout(stock, 80); }
  document.addEventListener('change', stockSoon);
  document.addEventListener('variant:change', stockSoon);
  document.addEventListener('product:variant-change', stockSoon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pill(); stock(); });
  else { pill(); stock(); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();